import React from 'react';

export default function DeleteIcon() {
  return (
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <g
        id="delete"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="ic/delete_outline">
          <g transform="translate(5.000000, 3.000000)">
            <mask id="mask-2-delete" fill="white">
              <path
                d="M1,16 C1,17.1 1.9,18 3,18 L11,18 C12.1,18 13,17.1 13,16 L13,4 L1,4 L1,16 Z M3,6 L11,6 L11,16 L3,16 L3,6 Z M10.5,1 L9.5,0 L4.5,0 L3.5,1 L0,1 L0,3 L14,3 L14,1 L10.5,1 Z"
                id="path-1-delete"></path>
            </mask>
            <g id="Shape" fillRule="nonzero"></g>
            <g id="Red-/-R400" mask="url(#mask-2-delete)" fill="#DE350B">
              <g transform="translate(-5.000000, -3.000000)" id="R400">
                <rect x="0" y="0" width="24" height="24"></rect>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
